import React, { useEffect, useState } from "react"
import ReactDOM from "react-dom"
import { PageType } from "../pagetype"
import "./index.less"

export function DelayTips(props: { pagetype: PageType }) {
  const [trangleClass, setTrangleClass] = useState(false)

  const clickTrangle = () => {
    if (trangleClass) {
      setTrangleClass(false)
    } else {
      setTrangleClass(true)
    }
  }

  return (
    <>
      {props.pagetype == PageType.瑞士GDR && (
        <span>
          <span className="delay-title">延</span>
          <i
            className={`delay-icon-trangle ${trangleClass ? "rotate" : ""}`}
            onClick={(e) => {
              e.preventDefault()
              clickTrangle()
            }}
          ></i>
        </span>
      )}
      {trangleClass && (
        <>
          <DelayTitle onClose={() => setTrangleClass(false)} />
          <DelayPopMask onClose={() => setTrangleClass(false)} />
        </>
      )}
    </>
  )
}

export function DelayPopMask(props: { onClose: Function }) {
  const close = () => {
    props.onClose()
  }
  return ReactDOM.createPortal(<div className="delay-pop-mask" onClick={close}></div>, document.body)
}

export function DelayTitle(props: { onClose: Function }) {
  const [isAd,setIsAd] = useState(true)

  const close = () => {
    props.onClose()
  }

  useEffect(()=>{
    if(!$("#ad-header")?.[0]){
      setIsAd(false)
    }
  },[])

  return (
    <>
      <div className={`delay-container ${isAd?"":"delay-container-no-ad"}`} onClick={close}>
        <div className="delay-left">延</div>
        <div className="delay-right">
          <p className="delay-subtitle">延迟行情</p>
          <p className="delay-content">应交易所要求，当前为15分钟延迟行情</p>
        </div>
      </div>
    </>
  )
}
